import { house } from '@/xhr/services/house'
import assert from 'assert'

export async function startForm(params, houseSpaceIds) {
  try {
    const res = await house.post(`/house/flow/startshelveHouseProcess`, {
      houseSpaceIds,
      ...params,
    })
    assert(res, '房源服务未能正常响应')
    assert(res.status === 200, '房源服务未能正常响应')
    assert(res.data.code === 200, `流程发起失败。${res.data.message}`)
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/HouseWithdrawForm/api/index.js